import createOneUpChild from 'emun.cart/cart.create-component'
import templateUrl from 'emun.cart/continue-shopping.htm'

export default createOneUpChild(templateUrl);